import {
  SHOW_CUSTOMER_DETAILS,
  SHOW_LEFT_SIDE_IN_CONTACT_PAGE,
  SHOW_RIGHT_SIDE_IN_CHAT,
  SHOW_SEARCH_BAR,
  SHOW_MESSAGE_INFO_BAR,
  SHOW_MEDIA_BAR,
  SHOW_STARRED_MESSAGES_BAR,
  SHOW_PHOTO_MODAL,
} from "./constants";

const showCustomerDetailsAction = (value) => ({
  type: SHOW_CUSTOMER_DETAILS,
  value,
});

const showLeftSideInContactsPage = (value) => ({
  type: SHOW_LEFT_SIDE_IN_CONTACT_PAGE,
  value,
});

const showRightSideInChat = (value) => ({
  type: SHOW_RIGHT_SIDE_IN_CHAT,
  value,
});

const showSearchBarAction = (value) => ({
  type: SHOW_SEARCH_BAR,
  value,
});

const showMessageInfoBarAction = (value) => ({
  type: SHOW_MESSAGE_INFO_BAR,
  value,
});

const showMediaBar = (value) => ({
  type: SHOW_MEDIA_BAR,
  value,
});

const showStarredMessagesBar = (value) => ({
  type: SHOW_STARRED_MESSAGES_BAR,
  value,
});

const showPhotoModal = (value, body, contentType) => ({
  type: SHOW_PHOTO_MODAL,
  value,
  body,
  contentType,
});

export {
  showCustomerDetailsAction,
  showLeftSideInContactsPage,
  showRightSideInChat,
  showSearchBarAction,
  showMessageInfoBarAction,
  showMediaBar,
  showStarredMessagesBar,
  showPhotoModal,
};
